import { render, staticRenderFns } from "./BaseVoucher.vue?vue&type=template&id=6faa4833&scoped=true&"
import script from "./BaseVoucher.vue?vue&type=script&lang=js&"
export * from "./BaseVoucher.vue?vue&type=script&lang=js&"
import style0 from "./BaseVoucher.vue?vue&type=style&index=0&id=6faa4833&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faa4833",
  null
  
)

export default component.exports